import React from 'react';
import Header from "../../components/landing-page-new/header/Header";
import LandingPageFooter from "../../components/landing-page/landing-footer/LandingPageFooter";
import Description from "../../components/landing-page-new/description/Description";

const TermsAndConditions = () => {
    return (
        <>
            <Header/>
            <Description
                title="Terms and Conditions"
                description="Our terms and conditions outline the use of AI in transportation, ensuring transparency, compliance, and ethical practices. By using OpenShipAI’s services, you agree to adhere to these principles and ensure responsible usage."
                subDescriptions={[
                    {
                        title: "1. Transparency",
                        content: "Transparency is a cornerstone of OpenShipAI’s operations. We ensure that all AI-driven processes are documented and accessible, providing clear information on how data is processed, analyzed, and utilized. Specifically:",
                        list: [
                            "Providing detailed documentation for all automated decision-making processes.",
                            "Ensuring that users have access to insights generated by AI tools.",
                            "Regularly publishing updates and changes to algorithms and their intended uses."
                        ]
                    },
                    {
                        title: "2. Compliance",
                        content: "OpenShipAI’s AI systems comply with industry standards and regional regulations, including but not limited to:",
                        list: [
                            "Adherence to GDPR, CCPA, and similar global data privacy laws.",
                            "Regular audits to ensure alignment with evolving compliance requirements.",
                            "Ensuring that transportation practices meet local and international legal standards."
                        ]
                    },
                    {
                        title: "3. Ethical Practices",
                        content: "Our commitment to ethical AI ensures that our technology benefits users without causing harm. This includes:",
                        list: [
                            "Avoiding biases in AI decision-making by conducting regular evaluations.",
                            "Promoting fair treatment of all users, including shippers and carriers.",
                            "Implementing safeguards to prevent misuse of AI technology."
                        ]
                    },
                    {
                        title: "4. User Responsibilities",
                        content: "All users of OpenShipAI’s platform are expected to uphold the integrity and security of the system. Users must:",
                        list: [
                            "Provide accurate information for shipments and other operations.",
                            "Avoid attempting to manipulate or exploit AI-driven processes.",
                            "Report any suspicious activities or potential security breaches immediately."
                        ]
                    },
                    {
                        title: "5. Data Ownership and Security",
                        content: "OpenShipAI respects your ownership of data while ensuring its security through advanced measures. Key points include:",
                        list: [
                            "Users retain ownership of data provided to OpenShipAI, with explicit consent for its usage.",
                            "Data is secured using encryption, regular security audits, and access controls.",
                            "User data will not be sold or misused under any circumstances."
                        ]
                    },
                    {
                        title: "6. Limitations of Liability",
                        content: "While OpenShipAI strives to provide accurate and reliable services, certain limitations apply:",
                        list: [
                            "OpenShipAI is not liable for damages arising from user error or misuse of the platform.",
                            "Service interruptions due to unforeseen circumstances, such as technical issues, are addressed promptly but may cause temporary delays.",
                            "Users are responsible for compliance with laws and regulations relevant to their operations."
                        ]
                    },
                    {
                        title: "7. Dispute Resolution",
                        content: "In the event of disputes, OpenShipAI encourages resolution through communication. If necessary, formal measures include:",
                        list: [
                            "Mediation services to facilitate agreement between parties.",
                            "Binding arbitration as a final step in unresolved disputes.",
                            "Ensuring that all dispute resolutions are conducted fairly and transparently."
                        ]
                    },
                    {
                        title: "8. Updates to Terms and Conditions",
                        content: "OpenShipAI reserves the right to update these terms as needed. Notifications for updates will include:",
                        list: [
                            "Email alerts to registered users regarding significant changes.",
                            "Prominent notices on our website for transparency.",
                            "Regular reminders to review terms for continued compliance."
                        ]
                    },
                    {
                        title: "9. Contact Us",
                        content: "For inquiries, support, or clarification regarding these terms, users can contact OpenShipAI through:",
                        list: [
                            "Email: support@openshipai.com",
                            "Phone: +1-800-555-TRANSPORT",
                            "Address: 123 Logistics Lane, Innovation City, USA."
                        ]
                    }
                ]}
            />
            <LandingPageFooter/>
        </>
    );
};

export default TermsAndConditions;